module.exports = __webpack_public_path__ + "static/media/Speaker_name.adacd233.svg";